import React, { Component } from "react";
import { login } from "../Auth/auth";
import { Link } from "react-router-dom";

export class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "", password: "", error: false };
  }

  handleChange(event) {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleClick(event) {
    event.preventDefault();
    const { email, password } = this.state;
    login(email, password).then((ok) => {
      if (ok) {
        this.props.onLogin();
      } else {
        this.setState({ error: true });
      }
    });
  }

  render() {
    const { email, password, error } = this.state;
    return (
      <div className="container my-5">
        <div className="row">
          <div className="col-12">
            <h3>Page de connexion</h3>
          </div>
        </div>
        <div className="row my-3">
          <div className="col-12 col-md-8 col-lg-6">
            <form>
              <div className="form-group">
                <label>Email</label>
                <input
                  className="form-control"
                  type="text"
                  name="email"
                  value={email}
                  onChange={this.handleChange.bind(this)}
                />
              </div>

              <div className="form-group">
                <label>Mot de passe</label>
                <input
                  className="form-control"
                  type="password"
                  name="password"
                  value={password}
                  onChange={this.handleChange.bind(this)}
                />
              </div>

              <p className="text-danger small mt-2">
                {error && "Identifiant et/ou mot de passe invalide(s). "}
              </p>

              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleClick.bind(this)}
              >
                Login
              </button>

              <p className="my-4">
                Vous n'avez pas de compte ?{" "}
                <Link
                  to={`/compte/creer-compte`}
                  className="text-primary text-decoration-none itemTri"
                >
                  Créer un compte
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
